/**
 * @generated SignedSource<<31b09ae11000f90e43ff183ea3a046b5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NavigationTeamButton_project$data = {
  readonly id: string;
  readonly teamsConnected: {
    readonly " $fragmentSpreads": FragmentRefs<"TeamButtonDataConnectedComponent">;
  } | null | undefined;
  readonly " $fragmentType": "NavigationTeamButton_project";
};
export type NavigationTeamButton_project$key = {
  readonly " $data"?: NavigationTeamButton_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavigationTeamButton_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "NavigationTeamButton_project",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "consistentRead",
          "value": true
        }
      ],
      "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
      "kind": "LinkedField",
      "name": "teamsConnected",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "TeamButtonDataConnectedComponent"
        }
      ],
      "storageKey": "teamsConnected(consistentRead:true)"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "910a0c5ae4e159357f4280ee5d9fd629";

export default node;
